var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBilling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.933 0.5H3.63497C2.3073 0.5 1.13283 1.39435 0.924193 2.70597C0.238474 7.01434 0.466074 12.2331 1.02632 16.9412C1.16347 18.0807 2.51302 18.5855 3.38257 17.8356L5.21359 16.2599L6.61858 17.7918C6.82437 18.0159 7.07461 18.1946 7.35334 18.3165C7.63206 18.4385 7.93315 18.501 8.23738 18.5C8.54162 18.499 8.8423 18.4346 9.12026 18.311C9.39821 18.1873 9.64732 18.007 9.85168 17.7816L11.2304 16.2613L13.1256 17.875C13.9923 18.6147 15.3272 18.1201 15.4702 16.9894C16.0611 12.3338 16.3441 6.86406 15.5942 2.60968C15.371 1.34183 14.2213 0.5 12.933 0.5Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2679 6.20941C10.2679 6.20941 9.51798 5.37196 8.30119 5.477C7.08586 5.58205 6.49935 6.32905 6.49935 7.07896C6.49935 9.26451 10.2679 7.75009 10.2679 9.99108C10.2679 11.1466 7.7672 11.9622 6.27759 10.6039M8.45147 4.00781V5.46679M8.45147 11.2998V12.7617",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "static/media/billing.ab13ccdc321b5035f98d4fa73e3f34d1.svg";
export { ForwardRef as ReactComponent };